import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import React from 'react'
import { Form, Select } from 'antd'

const { Option } = Select

const options = ['Ad-Hoc', 'Daily', 'Weekly', 'Monthly', 'Quarterly', 'Annually']

const UpdateFrequencySelect = () => {
  return (
    <>
      <span>{FIELD_LABEL.UPDATE_FREQUENCY_SELECT}</span>
      <Form.Item
        name={FIELD_NAME.UPDATE_FREQUENCY}
        rules={[RULES.REQUIRED]}
      >
        <Select
          bordered={false}
          placeholder={'Update Frequency'}
          size='large'
          style={{ background: '#fff' }}
        >
          {options.map((option, index) => (
            <Option
              key={index}
              value={option}
            >
              {option}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  )
}

export default UpdateFrequencySelect
